import { Form, Modal, ModalProps } from "react-bootstrap";
import { getPortraitViewportContainer } from "../compoment/PortraitStage";
import { useEffect, useRef, useState } from "react";
import { getActivePinCode } from "../services/pinService";
import { CloseCircle } from "../compoment/icon";

interface OTPModalProps extends ModalProps {
  onHide: () => void;
  onSuccess?: () => void;
}

const OTPModal = (props: OTPModalProps) => {
  const currentRefs = useRef<(HTMLInputElement | null)[]>([]);
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  const [currentPin, setCurrentPin] = useState(Array(6).fill(""));
  const [pinError, setPinError] = useState("");
  const [correctPin, setCorrectPin] = useState<string | null>(null);
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    type: "current"
  ) => {
    const { value } = e.target;
    if (!/^\d*$/.test(value)) return;

    if (type === "current") {
      const updated = [...currentPin];
      updated[index] = value.slice(-1);
      setCurrentPin(updated);

      if (value && index < currentRefs.current.length - 1) {
        currentRefs.current[index + 1]?.focus();
      }
      if (updated.every((d) => d !== "")) {
        const enteredPin = updated.join("");
        if (correctPin && enteredPin === correctPin) {
          props.onSuccess?.();
          props.onHide();
        } else {
          setPinError("Incorrect PIN. Please try again.");
          setCurrentPin(Array(6).fill(""));
          window.setTimeout(() => currentRefs.current[0]?.focus(), 100);
        }
      }
    }
  };
  useEffect(() => {
    if (!props.show) {
      setCorrectPin(null);
      setCurrentPin(Array(6).fill(""));
      setPinError("");
      return;
    }

    let cancelled = false;
    setPinError("");
    getActivePinCode().then((result) => {
      if (cancelled) return;
      if (result.success) setCorrectPin(result.pinCode);
      else setPinError(result.error);
    });
    return () => {
      cancelled = true;
    };
  }, [props.show]);

  useEffect(() => {
    const threshold = 150; // px difference to assume keyboard is open
    let initialHeight = window.innerHeight;

    const handleResize = () => {
      const diff = initialHeight - window.innerHeight;
      if (diff > threshold) {
        setKeyboardOpen(true);
      } else {
        setKeyboardOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number,
    type: "current"
  ) => {
    if (e.key === "Backspace") {
      if (type === "current" && !currentPin[index] && index > 0) {
        currentRefs.current[index - 1]?.focus();
      }
    }
  };

  return (
    <Modal
      container={() => getPortraitViewportContainer() ?? document.body}
      {...props}
      backdrop="static"
      fullscreen
      className={`otpModal ${keyboardOpen ? "keyboard-open" : ""}`}
      keyboard={false}
      scrollable={false}
    >
      <Modal.Body>
        <div className="otpModalBody">
          <div>
            <button
              className="back"
              aria-label="Close"
              onClick={() => props.onHide()}
            >
              <CloseCircle />
            </button>
          </div>
          <div className="header">Enter your PIN code to access Admin Mode</div>
          <div className="d-flex align-items-center justify-content-center gap-2">
            {currentPin.map((digit, index) => (
              <Form.Control
                key={index}
                ref={(el: any) => (currentRefs.current[index] = el)}
                value={digit}
                onChange={(e: any) => handleChange(e, index, "current")}
                onKeyDown={(e: any) => handleKeyDown(e, index, "current")}
                maxLength={1}
                placeholder=""
                className="px-1 text-center"
                type="password"
                inputMode="numeric"
                pattern="[0-9]*"
              />
            ))}
          </div>
          {pinError && <div className="text-danger text-center mt-3 mb-2">{pinError}</div>}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default OTPModal;
